<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Listar Ingressos</h2>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">Ingressos:</p>
            <b-form-checkbox-group>
              <b-form-checkbox-group @input="updateForm('type', $event)" :checked="filters.type" :options="typeOptions"></b-form-checkbox-group>
            </b-form-checkbox-group>
          </b-form-group>

          <b-form-group class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">Status:</p>
            <b-form-checkbox-group @input="updateForm('status', $event)" :checked="filters.status" :options="statusOptions"></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-v="end">
        <b-col>
          <div class="w-auto d-inline-block mr-4 mb-4">
            <p class="mb-2 font-weight-bold">Filtros:</p>
            <b-button class="mr-1 mb-1" v-b-modal.filter-origin>Origem</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-number>Número</b-button>
            <b-button v-if="!randomNumberEnabled" class="mr-1 mb-1" v-b-modal.filter-range>Intervalo</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-batch>Lote</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-dealer>Revendedor</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-date>Data geração</b-button>
          </div>
          <div style="width: 110px;" class="d-inline-block mr-4 mb-4">
            <p class="mb-2 font-weight-bold">Quantidade:</p>
              <b-form-input size="sm" type="number" @input="updateForm('limit', $event)" :value="filters.limit"></b-form-input>
          </div>
          <div class="w-auto d-inline-block mr-4 mb-4">
            <b-button class="mr-1" variant="info" @click="showLast">Limpar filtros</b-button>
            <b-button class="mr-1" variant="info" @click="filter">Filtrar</b-button>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" v-if="hasFilters" class="mt-1 mb-3">
          <b-card-group>
            <b-card no-body>
              <b-list-group flush>
                <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                  <strong>{{ item.filter }}:</strong> {{ item.values }}
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
        </b-col>

        <b-col cols="12" class="mt-0">
          <p class="m-0">{{ stats }}</p>
        </b-col>

        <b-col cols="12" class="mt-3">
          <b-table striped hover show-empty
            :items="tickets"
            :fields="fields"
            primary-key="number"
            sort-icon-left
            empty-filtered-text="Nenhum ingresso encontrado"
            empty-text="Nenhum ingresso encontrado"
            responsive>

              <template v-slot:head(statusStyled)="">
                <div>
                  Status
                  <span v-b-tooltip.hover title="Ingressos validados parcialmente ou não validados aparecem com status Ativo.">
                    <icon name="info-circle" scale="0.8"></icon>
                  </span>
                </div>
              </template>

              <template v-slot:cell(statusStyled)="data">
                <div>
                  <div v-if="data.item.status === 'canceled' && data.item.canceled_by === 'admin'">
                    <b-badge pill variant="danger">Cancelado</b-badge>
                    <icon scale="0.92" class="ml-1 text-secondary" name="user-shield" v-b-tooltip.hover.right="'Cancelado via Administrador'"></icon>
                  </div>
                  <div v-else-if="data.item.status === 'canceled' && data.item.canceled_by === 'transfer'">
                    <b-badge pill variant="danger">Cancelado</b-badge>
                    <icon scale="0.92" class="ml-1 text-danger" name="exchange-alt" v-b-tooltip.hover.right="'Cancelado via Alteração de Titularidade'"></icon>
                  </div>
                  <div v-else-if="data.item.status === 'canceled' && data.item.canceled_by === 'pos'">
                    <b-badge pill variant="danger">Cancelado</b-badge>
                    <icon scale="0.92" class="ml-1 text-danger" name="cash-register" v-b-tooltip.hover.right="'Cancelado via Maquininha'"></icon>
                  </div>
                  <b-badge v-else-if="data.item.status === 'validated'" pill variant="success">Validado</b-badge>
                  <b-badge v-else pill variant="primary">Ativo</b-badge>
                </div>
              </template>

              <template v-slot:cell(actions)="data">
                <div>
                  <b-dropdown variant="secondary" size="sm" class="mr-1" no-caret boundary="window">
                    <template #button-content>
                      <icon name="ellipsis-v" scale="1" class="mt-2 mb-0 ml-2"></icon>
                    </template>
                    <b-dropdown-item @click="downloadTicket(data.item.number)" :disabled="downloading[data.item.number]">
                      <b-spinner small v-if="downloading[data.item.number]" class="mr-2"></b-spinner>
                      <icon v-else name="download" scale="1" class="mr-2"></icon>
                      Download ingresso
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>

          </b-table>
        </b-col>
      </b-row>

    </b-container>

    <b-modal id="filter-origin"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Origem"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>
      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('origins', $event)"
          :checked="filters.origins"
          :options="originsOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-dealer"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Revendedor"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>
      <b-input-group class="mb-3" size="sm">
        <b-form-input v-model="search.dealer" placeholder="Pesquisa rápida" :autofocus="true" type="search"></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.dealer" @click="search.dealer = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('dealers', $event)"
          :checked="filters.dealers"
          :options="dealersOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-batch"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Lote"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>
      <b-input-group class="mb-3" size="sm">
        <b-form-input v-model="search.batch" placeholder="Pesquisa rápida" :autofocus="true" type="search"></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.batch" @click="search.batch = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('batches', $event)"
          :checked="filters.batches"
          :options="batchesOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-number"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Número"
      ok-variant="info"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe os números e clique em <span class="font-weight-bold">Filtrar</span></p>
      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('numbers', $event)"
          :value="filters.numbers"
          placeholder="Exemplo: 1,2,3"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.numbers" @click="filters.numbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-range"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Intervalo"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe o intervalo de números e clique em <span class="font-weight-bold">Filtrar</span></p>
      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('rangeNumbers', $event)"
          :value="filters.rangeNumbers"
          placeholder="Exemplo: 1-25"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.rangeNumbers" @click="filters.rangeNumbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-date"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Data"
      @ok="filter"
      :ok-disabled="filters.createdAt.start === '' || filters.createdAt.end === ''"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Para filtrar um <span class="font-weight-bold">intervalo de datas</span>, selecione dois dias. Para filtrar um <span class="font-weight-bold">dia específico</span>, clique duas vezes nele. Após isso clique em <span class="font-weight-bold">Filtrar</span>.</p>
      <div class="text-center">
        <calendar
          @input="updateForm('createdAt', $event)"
          :value="filters.createdAt"
          :min-date="eventCreatedAt"
        >
        </calendar>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Calendar from '@/components/Calendar'
import FilterStore from '@/filterStore'

export default {
  name: 'AdminListTickets',
  components: {
    Calendar
  },
  data () {
    return {
      eventId: '',
      randomNumberEnabled: false,
      batches: [],
      dealers: [],
      tickets: [],
      appliedFilters: [],
      downloading: {},
      filters: {
        limit: 10,
        dealers: [],
        batches: [],
        numbers: '',
        rangeNumbers: '',
        createdAt: {
          start: '',
          end: ''
        },
        type: ['printed', 'digital'],
        origins: [],
        status: ['active', 'validated', 'canceled']
      },
      search: {
        dealer: '',
        batch: ''
      },
      fields: [
        { key: 'number', label: 'Nro.', class: ['align-middle', 'text-center'] },
        { key: 'statusStyled', label: 'Status', class: ['align-middle', 'text-center'] },
        { key: 'name', label: 'Lote', class: ['align-middle', 'text-nowrap'] },
        { key: 'dealer', label: 'Revendedor', class: ['align-middle', 'text-nowrap'] },
        { key: 'type', label: 'Tipo', formatter: this.$options.filters.ticketType, class: ['align-middle', 'text-center'] },
        { key: 'origin', label: 'Origem', formatter: this.$options.filters.ticketOrigin, class: ['align-middle', 'text-center', 'text-nowrap'] },
        { key: 'created_at', label: 'Data geração', formatter: this.$options.filters.date, class: ['align-middle', 'text-nowrap', 'text-center'] },
        { key: 'actions', label: 'Ações', class: ['text-nowrap', 'text-center', 'align-middle'] }
      ],
      originsOptions: [
        { text: 'Sistema', value: 'dashboard' },
        { text: 'Aplicativo', value: 'app' },
        { text: 'Loja virtual', value: 'shop' }
      ],
      statusOptions: [
        { text: 'Ativos', value: 'active' },
        { text: 'Validados', value: 'validated' },
        { text: 'Cancelados', value: 'canceled' }
      ],
      typeOptions: [
        { text: 'Impressos', value: 'printed' },
        { text: 'Digitais', value: 'digital' }
      ],
      eventCreatedAt: '',
      filterStore: ''
    }
  },
  async created () {
    this.filterStore = new FilterStore(this.$route.params.id, this.$route.path)
    this.filters = this.filterStore.merge(this.filters)
  },
  async mounted () {
    this.eventId = this.$route.params.id
    await this.getEvent()
    await this.filter()
  },
  methods: {
    updateForm (input, value) {
      this.filters[input] = value
      this.filterStore.save(input, value)
    },
    async getEvent () {
      let url = process.env.VUE_APP_URL_APP + '/b/events/' + this.eventId

      try {
        let res = await this.$http.get(url)

        if (res.body.batches && res.body.batches.length > 0) {
          this.batches = this.$_.orderBy(res.body.batches, ['id'], ['asc'])
        }

        if (res.body.dealers && res.body.dealers.length > 0) {
          this.dealers = this.$_.orderBy(res.body.dealers, ['id'], ['asc'])
        }

        if (res.body.created_at) {
          this.eventCreatedAt = this.$moment(res.body.created_at).format('YYYY-MM-DD 00:00:00')
        }

        this.randomNumberEnabled = res.body.random_number_enabled === 1

        return true
      } catch (e) {
        console.error(e)
      }
      return false
    },
    async getTickets (filters) {
      let url = process.env.VUE_APP_URL_APP + '/b/events/' + this.eventId + '/tickets'

      if (filters !== '' && filters !== undefined) {
        url = url + '?' + filters
      }

      try {
        let resp = await this.$http.get(url)
        this.tickets = resp.body.tickets || []
        return true
      } catch (e) {
        console.error(e)
      }
      return false
    },
    reset () {
      this.appliedFilters = []
      this.filters.dealers = []
      this.filters.batches = []
      this.filters.numbers = ''
      this.filters.rangeNumbers = ''
      this.filters.createdAt.start = ''
      this.filters.createdAt.end = ''
      this.filters.type = ['printed', 'digital']
      this.filters.origins = []
      this.filters.status = ['active', 'validated', 'canceled']
      this.filters.limit = 10
      this.filterStore.clear()
    },
    async filter () {
      let filters = []
      this.appliedFilters = []

      if (this.filters.dealers.length > 0) {
        filters.push('dealers=' + this.$_.join(this.filters.dealers, ','))
        let af = { filter: 'Revendedor', values: this.$_.join(this.filters.dealers, ', ') }
        this.appliedFilters.push(af)
      }

      if (this.filters.origins.length > 0) {
        filters.push('origins=' + this.$_.join(this.filters.origins, ','))
        let v = []
        this.$_.each(this.filters.origins, f => {
          let s = this.$_.find(this.originsOptions, d => d.value === f)
          v.push(s.text)
        })
        this.appliedFilters.push({ filter: 'Origem', values: this.$_.join(v, ', ') })
      }

      if (this.filters.batches.length > 0) {
        filters.push('batches=' + this.$_.join(this.filters.batches, ','))
        this.appliedFilters.push({ filter: 'Lote', values: this.$_.join(this.filters.batches, ', ') })
      }

      if (this.filters.limit > 0) {
        filters.push('limit=' + this.filters.limit)
      }

      if (this.filters.numbers !== '') {
        filters.push('numbers=' + this.filters.numbers)
        this.appliedFilters.push({ filter: 'Número', values: this.filters.numbers })
      }

      if (this.filters.rangeNumbers !== '') {
        filters.push('range_numbers=' + this.filters.rangeNumbers)
        let split = this.$_.split(this.filters.rangeNumbers, '-', 2)
        this.appliedFilters.push({ filter: 'Intervalo', values: 'Do ' + split[0] + ' até o ' + split[1] })
      }

      if (this.filters.createdAt.start !== '') {
        let start = this.$moment(this.filters.createdAt.start, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('start_created_at=' + start + ':00')
        this.appliedFilters.push({ filter: 'Impressão', values: 'A partir de ' + this.filters.createdAt.start })
      }

      if (this.filters.createdAt.end !== '') {
        let end = this.$moment(this.filters.createdAt.end, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('end_created_at=' + end + ':59')
        this.appliedFilters.push({ filter: 'Impressão', values: 'Até ' + this.filters.createdAt.end })
      }

      if (this.filters.type.length > 0) {
        filters.push('type=' + this.$_.join(this.filters.type, ','))
      }

      if (this.filters.status.length > 0) {
        filters.push('status=' + this.$_.join(this.filters.status, ','))
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }

      await this.getTickets(filters)
    },
    async showLast () {
      this.reset()
      await this.getTickets('limit=10')
    },
    async downloadTicket (number) {
      this.$set(this.downloading, number, true)

      try {
        const url = process.env.VUE_APP_URL_APP + '/b/admin/events/' + this.eventId + '/tickets/' + number + '/image'
        const response = await this.$http.get(url, { responseType: 'blob' })

        const blob = new Blob([response.data], { type: 'image/jpeg' })
        const blobUrl = window.URL.createObjectURL(blob)

        const filename = response.headers.get('x-filename') || ('easytick_ingresso_' + number + '.jpeg')

        const link = document.createElement('a')
        link.href = blobUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
      } catch (err) {
        console.error(err)
        this.$bvToast.toast('Erro ao baixar ingresso. Tente novamente.', {
          title: 'Erro',
          autoHideDelay: 3000,
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          solid: true
        })
      }

      this.$set(this.downloading, number, false)
    }
  },
  computed: {
    dealersOptions () {
      let filtered = this.dealers
      if (this.search.dealer) {
        filtered = this.$_.filter(this.dealers, d => d.name.toLowerCase().indexOf(this.search.dealer.toLowerCase()) >= 0)
      }
      return this.$_.map(filtered, b => ({ text: b.name, value: b.id }))
    },
    batchesOptions () {
      let filtered = this.batches
      if (this.search.batch) {
        filtered = this.$_.filter(this.batches, b => b.name.toLowerCase().indexOf(this.search.batch.toLowerCase()) >= 0)
      }
      return this.$_.map(filtered, b => ({ text: b.name, value: b.id }))
    },
    hasFilters () {
      return this.appliedFilters.length !== 0
    },
    stats () {
      let qty = this.tickets.length
      if (qty === 1) return `Exibindo 1 ingresso`
      else if (qty > 1) return `Exibindo ${qty} ingressos`
      return ''
    }
  }
}
</script>
